const currentLocation = window.location.host.slice(-14);
export const isAmplifyEnv = currentLocation === 'amplifyapp.com';
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isTestEnv = process.env.NODE_ENV === 'test';
